import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./full-fleet.scss";
import Header from "../_Common/header";
import { Button, Col, Container, Form, Image, Nav, Row, Tab, Pagination } from "react-bootstrap";

import { fleetTabsData } from "../../json/FullFleet/fleet-tabs.js";
import FleetService from "../../services/fleetService";

import sailingIcon from "../../assets/img/home/our-fleet/icons/sailing-boat.png";
import boatIcon from "../../assets/img/home/our-fleet/icons/boat.png";
import starIcon from "../../assets/img/home/our-fleet/icons/star.png";
import lightingIcon from "../../assets/img/home/our-fleet/icons/lighting.png";

import sailBoatsImg from "../../assets/img/home/our-fleet/sail-boats.png";
import sailYachtsImg from "../../assets/img/home/our-fleet/sail-yachts.png";
import motorYachtsImg from "../../assets/img/home/our-fleet/motor-yachts.png";
import speedBoatsImg from "../../assets/img/home/our-fleet/speed-boats.png";

import Aos from "aos";

export default function FullFleet() {
  console.log("Fleet Tabs Data:", fleetTabsData);
  const fleetImages = {
    sailBoats: sailBoatsImg,
    sailYachts: sailYachtsImg,
    motorYachts: motorYachtsImg,
    speedBoats: speedBoatsImg,
    ferryBoats: "/assets/ferry-boat/party-ferry-boat-feature-image.webp",
  };

  const [aosKey, setAosKey] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState("sail_boats_tab");
  const [currentPage, setCurrentPage] = useState(1);
  // Pagination removed, showing all items
  const [fleetData, setFleetData] = useState([]);
  const [isSticky, setIsSticky] = useState(false); // Sticky state
  const fleetGridRef = useRef(null); // Ref for scrolling
  const sentinelRef = useRef(null); // Ref for sticky sentinel
  const location = useLocation();
  const navigate = useNavigate();

  // Read URL params for active tab
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");

    // Check if category exists in our data keys
    const isValidCategory = categoryParam && FleetService.getValidTabKeys().includes(categoryParam);

    if (isValidCategory) {
      setActiveTabKey(categoryParam);
      // Wait for render then scroll
      setTimeout(() => {
        fleetGridRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      window.scrollTo(0, 0); // Default behavior
    }
  }, [location.search]); // Depend on search params

  useEffect(() => {
    Aos.init({ duration: 800, once: false }); // initialize AOS

    const handleResize = () => {
      if (window.innerWidth < 768) {
        // itemsPerPage logic removed
      } else {
        // itemsPerPage logic removed
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Load data when active tab changes
  useEffect(() => {
    const data = FleetService.getFleetCategory(activeTabKey);
    setFleetData(data);
  }, [activeTabKey]);

  // Sticky Navigation Observer... (keep as is)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: "-80px 0px 0px 0px" }
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) observer.unobserve(sentinelRef.current);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      Aos.refreshHard();
    }, 100);
  }, [aosKey]);

  const handleTabClick = (key) => {
    setAosKey((prev) => prev + 1);
    setActiveTabKey(key);
    setCurrentPage(1);
    // Update URL to preserve state
    navigate(`/full-fleet?category=${key}`, { replace: true });
  };

  const [activeSpecId, setActiveSpecId] = useState(null);
  const handleClick = () => {
    setActiveSpecId(false);
  };

  // Direct Booking Logic
  const handleBookNow = (yacht) => {
    const amount = 2000;
    const yachtName = encodeURIComponent(yacht.name);
    const razorpayUrl = `https://pages.razorpay.com/yachtmumbai?amount=${amount}&yacht_name=${yachtName}`;
    window.open(razorpayUrl, "_blank");
  };

  const handleViewDetails = (boat) => {
    const slug = boat.name.toLowerCase().replace(/\s+/g, '-');
    // Pass current active category as param
    navigate(`/fleet-detail/${slug}?category=${activeTabKey}`);
  };

  return (
    <React.Fragment>
      <Header />
      {/* OUR FLEET CONTENT */}
      <section className="our-fleet-section">
        <Container>
          <div className="our-fleet-content">
            <span
              className="premium-fleet-badge"
              data-aos="fade"
              data-aos-duration="2000"
              data-aos-anchor-placement="top-bottom"
            >
              <i className="ri-menu-4-line align-middle"></i>
              <span className="align-middle">PREMIUM FLEET COLLECTION</span>
            </span>
            <h2
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-anchor-placement="top-bottom"
            >
              Our Fleet
            </h2>
            <p
              data-aos="fade-up"
              data-aos-duration="2100"
              data-aos-anchor-placement="top-bottom"
            >
              From intimate sailboats to luxury motor yachts, discover the
              perfect vessel for your Mumbai maritime experience
            </p>
          </div>
        </Container>
      </section>

      {/* FLEET NAV TAB SECTION */}
      <section className="fleet-nav-tab-section">
        <Tab.Container
          id="left-tabs-example"
          activeKey={activeTabKey}
          onSelect={handleTabClick}
        >
          {/* TAB NAV */}
          {/* Sentinel for sticky detection */}
          <div ref={sentinelRef} style={{ height: "1px", width: "100%", visibility: "hidden" }}></div>
          <div className={`fleet-tabs-header ${isSticky ? "is-sticky" : ""}`}>
            <Container>
              <Nav variant="pills">
                {fleetTabsData.map((item) => (
                  <Nav.Item key={item.id}>
                    <Nav.Link eventKey={item.key} onClick={handleClick}>
                      <Image
                        className="align-middle"
                        src={
                          item.id === "01"
                            ? sailingIcon
                            : item.id === "02"
                              ? boatIcon
                              : item.id === "03"
                                ? starIcon
                                : item.id === "05" // New Ferry Boats icon
                                  ? boatIcon
                                  : lightingIcon
                        }
                        alt="icon"
                      />
                      <span className="align-middle">{item.name}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Container>
          </div>


        </Tab.Container>
      </section >

      {/* FLEET GRID SECTION */}
      < section className="fleet-grid-section" ref={fleetGridRef} style={{ scrollMarginTop: "100px" }
      }>
        <Container>
          <div className="fleet-grid-wrapper">
            <h3 className="section-title mb-4">
              Our collection of {activeTabKey === 'sail_boats_tab' ? "Sail Boats" :
                activeTabKey === 'sail_yachts_tab' ? "Sail Yachts" :
                  activeTabKey === 'motor_yachts_tab' ? "Motor Yachts" :
                    activeTabKey === 'speed_boats_tab' ? "Speed Boats" : "Ferry Boats"}
            </h3>
            <Row className="g-3 g-md-4">
              {fleetData.map((boat, idx) => (
                <Col lg={4} md={6} xs={12} key={idx} data-aos="fade-up" data-aos-delay={idx * 50}>
                  <div className="fleet-grid-card">
                    <div className="card-img-wrapper">
                      <Image
                        src={boat.image} // Service handles path normalization
                        className="img-fluid"
                        alt={boat.name}
                      />
                    </div>
                    <div className="card-content">
                      <h3>{boat.name}</h3>
                      <div className="capacity-info">
                        <i className="ri-group-line"></i>
                        <span>{boat.guestCount}</span>
                      </div>
                      <p>{boat.description}</p>
                      <div className="trip-info">
                        <strong>Trip:</strong>
                        <div className="trip-list">
                          {Array.isArray(boat.trip) ? boat.trip.map((t, i) => (
                            <div key={i} className="trip-text">{t}</div>
                          )) : <span className="trip-text">{boat.trip}</span>}
                        </div>
                      </div>
                      <div className="mt-3 wrapper-btn-view-details d-flex gap-2">
                        <Button
                          variant="outline-dark"
                          className="btn-view-details w-50"
                          onClick={() => handleViewDetails(boat)}
                        >
                          View Details
                        </Button>
                        <Button
                          className="btn-book-now w-50"
                          onClick={() => handleBookNow(boat)}
                        >
                          Book Now
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section >
      {/* BOOKING MODAL */}

    </React.Fragment >
  );
}
